import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { constant } from 'app/app.constants';
import { AgGridActionsEnum } from 'app/core/enums/ag-grid-actions.enums';
import { ReportTypeEnum } from 'app/core/enums/report-type.enum';
import { TabsUnverifiedTripsEnum } from 'app/core/enums/tabs-unverified-trips.enum';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { IForms } from 'app/core/interfaces/forms.interface';
import { PayorService } from 'app/core/services/payor.service';
import { CatchingErrorsService } from 'app/pages/A2-utils/ParentClass/catching-errors.service';
import { DateModel } from 'app/pages/A2-utils/ParentClass/parent-class-date.model';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { PayorsService } from 'app/pages/payors/payors.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { IMyOptions } from 'mydatepicker';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';
import { EncounterTypeEnum } from 'app/core/enums/encounter-type.enum';
import { GridOptions } from 'ag-grid';
import { GridLayoutStore } from 'app/utils/grid-layout-menu/grid-layout-store';

declare const $: any;

@Component({
  selector: 'app-encounters',
  templateUrl: './encounters.component.html',
  styleUrls: ['./encounters.component.scss'],
  providers: [GridLayoutStore]
})
export class EncountersComponent implements OnInit, OnDestroy {
  @ViewChild('formsUploadEncounters') formsUploadCard: T2CardComponent;
  @ViewChild('formsModalEncounters') private modal837File: T2CardComponent;
  @ViewChild('fileUploadEncounters') protected _fileUpload: ElementRef;

  isCLM = JSON.parse(localStorage.getItem('isCLM'));
  isAV = JSON.parse(localStorage.getItem('isAV'));
  activatedTab = TabsUnverifiedTripsEnum.ElectronicSubmissions;
  tabsUnverifiedTrips =
    constant.UNVERIFIED_TRIPS && constant.UNVERIFIED_TRIPS.TABS_UNVERIFIED_TRIPS
      ? constant.UNVERIFIED_TRIPS.TABS_UNVERIFIED_TRIPS
      : {
          ElectronicSubmissions: TabsUnverifiedTripsEnum.ElectronicSubmissions,
          Rejections: TabsUnverifiedTripsEnum.Rejections,
        };
  private readonly rejectionsTab = TabsUnverifiedTripsEnum.Rejections;
  toggleCalendar = 1;
  myRDPOptions: IMyOptions = {
    firstDayOfWeek: 'su',
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true,
    markCurrentDay: false
  };
  jsonPolicyDateFrom: any;
  jsonPolicyDateTo: any;
  changeDate: boolean;
  ptrDateBegin: DateModel;
  ptrDateEnd: DateModel;
  payorTypes = [];
  dropdownSettings = {};
  payorList = [];
  payorSelectedList = [];
  payorTypeId = undefined;
  selectedPayorType = null;
  isSelectPayorDisabled = false;
  activePayorType = false;
  showqty: null;
  showsent = false;
  selectedForm: number;
  forms: IForms[] = [];
  observables: Subscription[] = [];
  rowSelectedGrid = 0;
  totalRows = 0;
  fileName = '';
  uploadFile: any;
  subtractSevenDays = moment().subtract(7, 'days');
  subtractDay = moment().subtract(1, 'days');
  gridSelected: GridOptions;
  showSetPlanTypeAndRegionButtonAction = false;
  showDuplicates = false;

  get getStringTitle(): string {
    return this.activatedTab === TabsUnverifiedTripsEnum.Rejections ? 'Generate 837 File Rejection' : 'Generate 837 File';
  }

  constructor(
    private titleService: Title,
    protected _loading: T2LoadingService,
    protected service: DataProcessingService,
    private payorService: PayorsService,
    private payorsService: PayorService,
    private toastrAlertHelper: ToastrAlertHelper,
    protected tripService: ReservationService,
    private uploadService: UploadsService,
    private sweetAlert: SweetAlertHelper,
    protected catchingError: CatchingErrorsService
  ) {
  }

  ngOnInit(): void {
    this.initFromToCtrls();
    this.initDateBeginAndEnd();
    this.getPayorsAll();
    this.getFormAlls();
    this.initService();
    this.settingDropDown();
    this.rowSelectedGrid = 0;
    this.totalRows = 0;
    this.service.actionGrid.next({
      isSubmit: true, action: AgGridActionsEnum.hideColumn, selectedTab: TabsUnverifiedTripsEnum.ElectronicSubmissions
    });
  }

  getPayorsAll(): void {
    this.observables.push(
      this.payorService.getPayorsActiveInactive().subscribe((data) => {
        if (data && data.length) {
          this.initPayorList(data);
        }
      }, (er: any) => this.toastrAlertHelper.error(er.message))
    );
  }

  getFormAlls(): void {
    this.observables.push(
      this.service.getAllForms().subscribe(data => {
        if (data && data.length) {
          this.setFormList(this.genericFilterArray(data, 'formtypeid', ReportTypeEnum.Encounter837, 'equal'));
        }
      })
    );
  }

  initService(): void {
    this.observables.push(
      this.service.getPayorsType().subscribe((res) => {
        if (res) {
          this.payorTypes = res;
        }
      }),
      this.service.actionGrid$.subscribe({
        next: (res) => {
          if (res && res.isSubmit) {
            switch (res.action) {
              case AgGridActionsEnum.selectedRow:
                this.rowSelectedGrid = res.dataList.length;
                this.showSetPlanTypeAndRegionButtonAction = res.showSetPlanTypeAndRegionButton;
                break;
              case AgGridActionsEnum.rowCount:
                this.totalRows = res.dataList[0].rowCount;
                break;
              case AgGridActionsEnum.LoadData:
                this.rowSelectedGrid = 0;
                break;
              default:
                break;
            }
          }
        }
      }),
      this.service.changePlanType$.subscribe({
        next: (value) => {
          if (value === false) {
            this.loadDataToExport();
            this.service.setChangePlanType(null);
          }
        }
      })
    );
  }

  settingDropDown(): void {
    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select payor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
  }

  onChangeTabs(selectedTab: TabsUnverifiedTripsEnum): void {
    let textMessage = 'Encounters';
    this.activatedTab = selectedTab;
    let toogleColumn = AgGridActionsEnum.hideColumn;
    this.rowSelectedGrid = 0;
    switch (selectedTab) {
      case TabsUnverifiedTripsEnum.ElectronicSubmissions:
        toogleColumn = AgGridActionsEnum.showColumn;
        break;
      case TabsUnverifiedTripsEnum.Rejections:
        textMessage = 'Rejections';
        break;
    }
    this.service.actionGrid.next({isSubmit: true, action: toogleColumn, selectedTab});
    this.changeTitle(textMessage);
  }

  setPayorList(list: any[]): void {
    this.payorList = list.filter((f) =>
      [
        EncounterTypeEnum.ApprovedEncounter,
        EncounterTypeEnum.GeneratesEncounter,
      ].includes(f.encountertype)
    );
  }

  setFormList(list: any[]): void {
    this.forms = list;
  }

  changeTitle(message: string): void {
    this.titleService.setTitle(message);
    $('#main-header .page-title').html(message);
  }

  onDateExportSelectedFromTo(event: any, dateTrigger: number): void {
    event.formatted ? this.changeDate = true : this.changeDate = false;
    switch (dateTrigger) {
      case 0:
        event.formatted.trim() === '' ? this.ptrDateBegin = null : this.ptrDateBegin = event.formatted;

        if (this.jsonPolicyDateTo !== null && this.jsonPolicyDateTo !== undefined) {
          this.ptrDateEnd = this.formatDateRangeNgModel(this.jsonPolicyDateTo.date).formatedOut;
        } else {
          this.ptrDateEnd = null;
        }
        break;
      default:
        event.formatted.trim() === '' ? this.ptrDateEnd = null : this.ptrDateEnd = event.formatted;

        if (this.jsonPolicyDateFrom !== null && this.jsonPolicyDateFrom !== undefined) {
          this.ptrDateBegin = this.formatDateRangeNgModel(this.jsonPolicyDateFrom.date).formatedOut;
        } else {
          this.ptrDateBegin = null;
        }
        break;
    }
  }

  formatDateRangeNgModel(dateRange: { day: any, month: any, year: any }): { formatedOut: any } {
    const newDate = dateRange.month + '-' + dateRange.day + '-' + dateRange.year;
    return {formatedOut: moment(newDate).format('MM-DD-YYYY')};
  }

  beginDateFormat(): { year: number, month: number, day: number } {
    return {
      year: this.subtractSevenDays.year(),
      month: this.subtractSevenDays.month() + 1,
      day: this.subtractSevenDays.date()
    };
  }

  endDateFormat(): { year: number, month: number, day: number } {
    return {year: this.subtractDay.year(), month: this.subtractDay.month() + 1, day: this.subtractDay.date()};
  }

  initFromToCtrls(): void {
    this.jsonPolicyDateFrom = {date: this.beginDateFormat()};
    this.jsonPolicyDateTo = {date: this.endDateFormat()};
  }

  initDateBeginAndEnd(): void {
    this.ptrDateBegin = this.formatDateRangeNgModel(this.beginDateFormat()).formatedOut;
    this.ptrDateEnd = this.formatDateRangeNgModel(this.endDateFormat()).formatedOut;
  }

  initPayorList(data: any[]): void {
    this.clearSelectionPayors();
    const mappedList = this.mapListPayors(data);
    this.setPayorList(mappedList);
  }

  clearSelectionPayors() {
    this.payorSelectedList = [];
  }

  mapListPayors(
    data: any[]
  ): { id: number; itemName: string; encountertype: number }[] {
    return data.length
      ? data.map((p: any) => ({
          id: p.payorid,
          itemName: p.description,
          encountertype: p.encountertype,
        }))
      : [];
  }

  onTypePayorInactive(event: any) {
    this.selectedPayorType = event;
    this.listPayorType(this.activePayorType);
  }

  onShowInactivePayors(isActive: boolean) {
    this.activePayorType = isActive;
    this.listPayorType(isActive);
  }

  listPayorType(isActive: boolean) {
    this.observables.push(
      this.payorsService.getTypePayorsInactive(this.selectedPayorType, isActive).subscribe({
        next: (data) => {
          if (data && data.length) {
            const listPayorByType = this.mapListPayors(data);
            this.setPayorList(listPayorByType);
          } else {
            this.setPayorList([]);
          }
          this.clearSelectionPayors();
        },
        error: (err) => {
          this.toastrAlertHelper.error(err);
        }
      })
    );
  }

  genericFilterArray(arrayList: any[], itemArray: string, validator: any, logicalOperator: ('equal' | 'diff' | 'all')): any[] {
    if (arrayList.length) {
      switch (logicalOperator) {
        case 'equal':
          return arrayList.filter((f: any) => f[itemArray] === validator);
        case 'diff':
          return arrayList.filter((f: any) => f[itemArray] !== validator);
        default:
          return arrayList;
      }
    } else {
      return [];
    }
  }

  saveLayout(): void {
    this.service.actionGrid.next({
      isSubmit: true,
      action: AgGridActionsEnum.SaveLayout,
      selectedTab: this.activatedTab
    });
  }

  clearFiltersExport(): void {
    this.service.actionGrid.next({
      isSubmit: true,
      action: AgGridActionsEnum.ClearFilters,
      selectedTab: this.activatedTab
    });
  }

  clearSortExport(): void {
    this.service.actionGrid.next({isSubmit: true, action: AgGridActionsEnum.ClearSort, selectedTab: this.activatedTab});
  }

  submitRunAction(): void {
    this.loadDataToExport();
  }

  loadDataToExport(): void {
    this._loading.show();
    const begin = this.ptrDateBegin;
    const end = this.ptrDateEnd;

    const firstPayorSelectedList =
      (this.isCLM || this.isAV) ? constant.PAYOR_DEFAULT_RIDE2MD : this.payorSelectedList.map((item) => item.id)[0];

    const isResubmission = this.activatedTab === TabsUnverifiedTripsEnum.Rejections;

    this.observables.push(
      this.service
        .dataToExportTripsECM(
          begin,
          end,
          firstPayorSelectedList,
          this.showqty,
          this.showsent,
          isResubmission,
          this.showDuplicates ,
        )
        .finally(() => {
          this.showDuplicates  = false;
          this._loading.hiden();
        })
        .subscribe((data) => {
            if (data) {
              this.service.actionGrid.next({
                isSubmit: true,
                action: AgGridActionsEnum.LoadData,
                dataList: data,
                selectedTab: this.activatedTab
              });
              if (!data.length) {
                this.totalRows = 0;
              }
              this.rowSelectedGrid = 0;
            }
          },
          (error) => {
            this._loading.hiden();
            this.toastrAlertHelper.error(error.message);
          })
    );
  }

  isValidBtn(): boolean {
    return (this.jsonPolicyDateFrom === null || this.jsonPolicyDateTo === null || !this.payorSelectedList.length);
  }

  generate837File(): void {
    this.service.actionGrid.next({
      isSubmit: true,
      action: AgGridActionsEnum.generateFile,
      dataList: [
        {
          formIdSelected: this.selectedForm,
          isSubmitions: this.activatedTab === this.rejectionsTab
        }
      ]
    });
    this.modal837File.close();
  }

  loadDataToImport(): void {
    this.formsUploadCard.open();
    this.fileName = '';
    this.uploadFile = null;
    this._fileUpload.nativeElement.value = '';
  }

  public bringFileSelector(): void {
    this._fileUpload.nativeElement.click();
  }

  getProperties(event): void {
    this.fileName = event.srcElement.value;
    this.uploadFile = event.srcElement.files;
  }

  sendFile(): void {
    if (this.fileName !== '') {
      const URL = constant.URL_IMPORT_FILE_835 + '/' + this.payorSelectedList[0].id;
      this._loading.show();
      this.toastrAlertHelper.success('Importing file');
      this.observables.push(
        this.uploadService.makeFileRequest(URL, [], this.uploadFile)
          .finally(() => this._loading.hiden())
          .subscribe(
            (data) => this.validateProcess(data),
            (error) => this.toastrAlertHelper.error(this.catchingError.catchingModelState(error), '', {enableHTML: true})
          )
      );
    } else {
      this.toastrAlertHelper.warning('Please, choose a file');
    }
  }

  validateProcess(data: any): void {
    if (data.edifileid) {
      this.formsUploadCard.close();
      this.fileName = '';
      this.uploadFile = null;
      this.sweetAlert.createCustomAlert({title: 'Successfully import!', text: data.processlogs, type: 'success'});
    }
  }

  openModalForms(): void {
    this.selectedForm = undefined;
    this.modal837File.open();
  }

  ngOnDestroy(): void {
    if (this.observables.length) {
      this.observables.forEach(row => row.unsubscribe());
      this.observables = [];
    }
  }

  setNonDuplicate() {
    const selectedTab: TabsUnverifiedTripsEnum = 1;
    const toogleColumn = AgGridActionsEnum.duplicateTrips;
    const details = [{
      begin: this.ptrDateBegin,
      end: this.ptrDateEnd,
      firstPayorSelectedList: (this.isCLM || this.isAV) ? constant.PAYOR_DEFAULT_RIDE2MD : this.payorSelectedList.map((item) => item.id)[0],
      showqty: this.showqty,
      showsent: this.showsent,
      isResubmission: this.activatedTab === TabsUnverifiedTripsEnum.Rejections,
    }];
    this.service.actionGrid.next({ isSubmit: true, action: toogleColumn, dataList: details, selectedTab });
  }

  duplicateModifiers() {
    this.showDuplicates = true;
    this.loadDataToExport();
  }

  get disabledSetPlanTypeAndRegionButton(): boolean {
    return !this.showSetPlanTypeAndRegionButtonAction && this.rowSelectedGrid < 1;
  }

  get disabledButtonChangePlanType(): boolean {
    return this.rowSelectedGrid < 1;
  }

  get disabledDuplicateModifiersButton(): boolean {
    return !(this.payorSelectedList && this.payorSelectedList.length);
  }

  get isNotRejectionTab(): boolean {
    return this.activatedTab !== this.rejectionsTab;
  }

  setReservationPlanTypeAndRegion(): void {
    this.sweetAlert
      .createCustomAlert({
        title: 'Are you sure you want to change the plan type and region of the reservation?',
        text: 'You will not be able to revert this!',
        type: 'warning',
        showCancelButton: true,
      })
      .then((result) => {
        if (result && result.value) {
          const toogleColumn = AgGridActionsEnum.SetReservationPlanTypeAndRegion;
          this.service.actionGrid.next({ isSubmit: true, action: toogleColumn });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/Encounters/encounters.component.ts